// extracted by mini-css-extract-plugin
export default {"app-in-new-window__container":"appInNewWindow_app-in-new-window__container__yGfu1"};